import React, {Component} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

class Detail extends Component {
  state = {
    options: {
      credits: {
        enabled: false
      },
      chart: {
        type: 'bar'
      },
      title: null,
      colors: this.props.chatColor,
      xAxis: {
        lineWidth: 0,
        categories: [],
        crosshair: true,
        labels: {
          formatter() {
            let labelVal = this.value;
            let reallyVal = '';
            let lvl = labelVal.length;
            if (lvl > 1) {
              for (let i = 1; i <= lvl; i++) {
                reallyVal += labelVal.substr(i - 1, 1) + "<br/>";
              }
            }
            return reallyVal.substring(0, reallyVal.length - 5);
          }
        }
      },
      yAxis: {
        opposite: true,
        gridLineColor: 'rgba(61, 136, 241, 0.1)',
        title: null
      },
      legend: {
        itemStyle: {
          color: 'rgba(0, 0, 0, 0.65)',
          fontSize: 12,
          fontWeight: 'normal'
        },
        symbolWidth: 6,
        symbolHeight: 6,
      },
      plotOptions: {
        series: {
          borderRadiusTopLeft: 10,
          borderRadiusTopRight: 10
        },
        column: {
          pointWidth: 6,
          borderWidth: 0
        }
      },
      series: []
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.summary && nextProps.summary.histogram && this.state.options.series.length === 0) {
      const newHistogram = [];
      let index = null;
      if (nextProps.summary.histogram.categories && nextProps.summary.histogram.categories.length > 0) {
        for (let i = 0; i < nextProps.summary.histogram.categories.length; i++) {
          if (nextProps.summary.histogram.categories[i] === '注意力') {
            index = i;
          }
        }
      }
      for (let j = 0; j < nextProps.summary.histogram.series.length; j++) {
        newHistogram.push({
          name: `题目${j + 1}`,
          data: nextProps.summary.histogram.series[j].data.map((v, i) => {
            if (index !== i) {
              return v.score;
            }
          })
        });
      }
      this.setState({
        options: {
          xAxis: {
            categories: nextProps.summary.histogram.categories.filter(v => v !== '注意力')
          },
          series: newHistogram
        }
      });
    }
  }

  render() {
    const { options } = this.state;
    const { i18n, summary, themeColor } = this.props;

    return (
      <div className="detail video-mobile-box">
        <h1 className="detailTitle" style={{color: themeColor}}>{i18n.result.summaryDetailTitle}</h1>
        <h2>{i18n.result.analysisInfo}</h2>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
        />
        <h2>{i18n.result.personalityInfo}</h2>
        <ul className="summaryList">
          {summary && summary.mbti && summary.mbti.characteristics && summary.mbti.characteristics.map((item, index) => (
            <li key={index}>
              {item.title && <h1 style={{color: themeColor}}><span style={{backgroundColor: themeColor}} />{item.title}</h1>}
              {item.content && <p>{item.content}</p>}
            </li>
          ))}
        </ul>
        <h2>{i18n.result.characteristicsInfo.replace('${type}', summary.mbti && summary.mbti.mbtiType)}</h2>
        <ul className="summaryList">
          {summary && summary.mbti && summary.mbti.jobCharacteristics && summary.mbti.jobCharacteristics.map((item, index) => (
            <li key={index}>
              {item.title && <h1 style={{color: themeColor}}><span style={{backgroundColor: themeColor}} />{item.title}</h1>}
              {item.content && <p>{item.content}</p>}
            </li>
          ))}
        </ul>
        <h2>{i18n.result.occupationInfo.replace('${type}', summary.mbti && summary.mbti.mbtiType)}</h2>
        <ul className="summaryList summaryLists">
          {summary && summary.mbti && summary.mbti.occupations && summary.mbti.occupations.map((item, index) => (
            <li key={index}>
              {item.title && <h1>{index + 1}、{item.title}</h1>}
              {item.content && <p>{item.content}</p>}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default Detail;
